import React, { ReactElement } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {},
  })
);

const PageTitle: React.FC<{ title: String }> = ({ title }): ReactElement => {
  const classes = useStyles();
  return (
    <Typography variant="h6" className={classes.title} color="textSecondary">
      {title}
    </Typography>
  );
};

export default PageTitle;
